import React from 'react';
import { ICustomizableElement, ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { SectionTitleStyled, SubtitleStyled, TitleStyled } from './styles';

export interface SectionTitleProps extends ICustomizableElement, ITestingElement {
  title: string;
  subtitle?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle, className, 'data-test-id': dataTestId }) => {
  return (
    <SectionTitleStyled className={className} data-test-id={dataTestId} $withSubtitle={!!subtitle}>
      <TitleStyled data-test-id={dataTestId}>{title}</TitleStyled>
      {subtitle && <SubtitleStyled>{subtitle}</SubtitleStyled>}
    </SectionTitleStyled>
  );
};

export default SectionTitle;
